import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_UNSELECETD_LABEL } from '../../../constants';

const SelectBox = (props) => {
  let { value } = props;
  const {
    size,
    before,
    after,
    className,
    options,
    optGroups,
    onChange,
    disabled,
  } = props;

  if (typeof value === 'number') {
    value = value.toString();
  }

  const items = optGroups ? (
    <React.Fragment>
      {optGroups.map((optGroup) => (
        <optgroup key={optGroup.id} label={optGroup.name}>
          {optGroup.options && optGroup.options.map(({ id, name }) => (
            <option
              key={id}
              value={id}
            >
              {name}
            </option>
          ))}
        </optgroup>
      ))}
    </React.Fragment>
  ) : (
    <React.Fragment>
      {options && options.map(({ id, name }) => (
        <option
          key={id ? id : 'undefined'}
          value={id}
        >
          {typeof name !== 'undefined' ? name : DEFAULT_UNSELECETD_LABEL}
        </option>
      ))}
    </React.Fragment>
  );

  return (
    <div className={`selectWrapper ${className} ${size}`}>
      {before}
      <select value={value} onChange={onChange} disabled={disabled}>
        {items}
      </select>
      {after}
    </div>
  );

};

SelectBox.defaultProps = {
  size: 'md',
  className: '',
  disabled: false,
};

SelectBox.propTypes = {
  size: PropTypes.string.isRequired,
  before: PropTypes.node,
  after: PropTypes.node,
  className: PropTypes.string,
  options: PropTypes.array,
  optGroups: PropTypes.array,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default SelectBox;